import React from 'react';

import { StateHandlingModal } from '@eika-kortbetjening/state-handling-modal';

import piwik from '@/piwik/piwik';

import { Card } from '@generated-types';
import useText from '@hooks/use-text';
import DEFAULT_APP_NAMESPACE from '@utils/modal';

import ReopenCard from './ReopenCard';

import './ReopenCardModal.scss';

interface DigitalCardModalProps {
    card: Card;
    show: boolean;
    onClose: () => void;
}

const ReopenCardModal = ({ card, show, onClose }: DigitalCardModalProps) => {
    const { loadingBlockOpen } = useText();

    return (
        <StateHandlingModal
            appNamespace={DEFAULT_APP_NAMESPACE}
            centerContentHorizontally
            data-track-id={piwik.reopenCardForm.reopenCard.dataTrackId}
            data-track-linkname={piwik.reopenCardForm.reopenCard.dataTrackLinkname}
            id={piwik.reopenCardForm.reopenCard.dataTrackId}
            loadingText={loadingBlockOpen}
            setOpen={onClose}
            onClose={onClose}
            open={show}
            shouldCloseOnOverlayClick
        >
            <div className="reopen-card-container">
                <ReopenCard card={card} />
            </div>
        </StateHandlingModal>
    );
};

export default ReopenCardModal;
